import { Component, OnInit } from '@angular/core';
import { TimingService } from '../apis/timing.service';
import { Period } from '../viewModels/period';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.css']
})
export class PrintComponent implements OnInit {

  constructor(private api : TimingService ,private activateRoute: ActivatedRoute) { }

  data=[]
  periods = []
  break_id = undefined
  division = this.activateRoute.snapshot.paramMap.get('division');

  ngOnInit(): void {
    if(!this.division){
      this.division = '1'
    }

    this.api.print(this.division).subscribe(
      (data : any[])=>{
  this.data = data
        console.log(data)
        setTimeout(() => {
          window.print()
        }, 1);
      }
    )

    this.api.getHiararchyPeriods()
    .subscribe((data: Period[]) => {
      this.periods = data.filter((x) => x.type == 'session' ).sort((a, b) => a.start_hour > b.start_hour ? 0 : -1);
      this.break_id = data.find((x) => x.type == 'break')?.id
      console.log(this.periods)
    })
  }

}
